export default __webpack_public_path__ + "static/media/gallery_00.b479b872.jpg";